import { Component, Input } from '@angular/core';
import { RecipientStory } from '../services/recipient-repository.service';
import { recipientCardImageStyle } from './recipient-photo-framing';

@Component({ selector: 'app-recipient-cards', template: `
  <div class="recipient-grid" [class.featured]="recipients.length === 1" [class.pair]="recipients.length === 2">
    <article *ngFor="let recipient of recipients">
      <a class="recipient-card" [routerLink]="[detailBase, recipient.Slug]"
        [attr.aria-label]="'Read the story of ' + recipient.RecipientName">
      <div class="recipient-photo" [class.fit-whole-photo]="recipient.Photos[0]?.CardFitWholePhoto">
        <app-fitness-media-image *ngIf="recipient.Photos.length; else placeholder" [mediaId]="recipient.Photos[0].MediaId"
          [alt]="recipient.Photos[0].AltText || recipient.RecipientName" [width]="800" [dwStyle]="imageStyle(recipient.Photos[0])"></app-fitness-media-image>
        <ng-template #placeholder><span class="photo-placeholder" aria-hidden="true"><i class="fa fa-heart"></i></span></ng-template>
      </div>
      <div class="recipient-copy">
        <p class="recipient-season">{{ seasonLabel || recipient.ChallengeDefinition?.Name }}</p>
        <h3>{{ recipient.RecipientName }}</h3>
        <p class="recipient-description">{{ recipient.ShortDescription }}</p>
        <span class="story-link">Read their story <span aria-hidden="true"><i class="fa fa-arrow-right"></i></span></span>
      </div>
      </a>
    </article>
  </div>`, styleUrls: ['./recipients.scss'] })
export class RecipientCardsComponent {
  @Input() recipients: RecipientStory[] = [];
  @Input() seasonLabel = '';
  @Input() detailBase = '/recipients';
  readonly imageStyle = recipientCardImageStyle;
}
